var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('SmallLogo'),(_vm.loading)?_c('Loading',{attrs:{"status":_vm.status}}):_c('div',[_c('ArtistGallery'),_c('AlbumGallery',{attrs:{"albums":_vm.albums}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }